import { render, staticRenderFns } from "./_TransactionDetail.vue?vue&type=template&id=fd2eca32&scoped=true&"
import script from "./_TransactionDetail.vue?vue&type=script&lang=js&"
export * from "./_TransactionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2eca32",
  null
  
)

export default component.exports